import React, { useState, useEffect } from "react";
import Image from "next/image";
import Link from "next/link";
import { loginRequest } from "../../authConfig";

import { useAuth } from "react-oidc-context";

const Hero = () => {
  const auth = useAuth();
  const [showActions, setShowActions] = useState(false);
  
    useEffect(() => {
        if (auth.isAuthenticated){
            setShowActions(true);
        }
        else {
            setTimeout(() => {
                setShowActions(true);
            }, 3000); // Delay of 1 seconds to let the code figure out if you are signed in or not 
        }
    }, [auth.isAuthenticated]);
    
    const handleLoginRedirect = () => {
    auth.signinRedirect()
  };

  return (
    <section className="relative pb-10 pt-20 md:pt-32 h-1527">
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 block dark:hidden h-full">
        <Image
          width={1519}
          height={760}
          src="/images/gradient.jpg"
          alt="gradient"
          className="h-full w-full object-cover"
        />
      </picture>
      <picture className="pointer-events-none absolute inset-x-0 top-0 -z-10 hidden dark:block">
        <Image
          width={1519}
          height={760}
          src="/images/gradient_dark.jpg"
          alt="gradient dark"
          className="h-full w-full object-cover"
        />
      </picture>

      <div className="container h-full mx-auto">
          <div className="grid h-full items-center gap-4 md:grid-cols-12">
              <div
                  className="col-span-6 flex h-full flex-col items-center justify-center py-10 md:items-start md:py-20 xl:col-span-4">
                  <h1 className="text-jacarta-700 font-bold font-display mb-6 text-center text-5xl dark:text-white md:text-left lg:text-6xl xl:text-7xl">
                      Buy, sell and collect CADRs.
                  </h1>
                  <p className="dark:text-jacarta-200 mb-8 text-center text-lg md:text-left">
                      The worlds #1 Carbon Asset Registry
                  </p>
                  <div
                      id="heroActions"
                      className={`flex space-x-4 transition-opacity duration-1000 ${
                          showActions ? "opacity-100" : "opacity-0"
                      }`}
                  >
                      {auth.isAuthenticated && (
                          <Link
                              href="/collection/explore_collection"
                              className="bg-accent shadow-accent-volume hover:bg-accent-dark w-36 rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                          >
                              Projects
                          </Link>
                      )}
                      {auth.isAuthenticated && (
                          <Link
                              href="/pledges"
                              className="text-accent shadow-white-volume hover:bg-accent-dark hover:shadow-accent-volume w-36 rounded-full bg-white py-3 px-8 text-center font-semibold transition-all hover:text-white"
                          >
                              Pledges
                          </Link>
                      )}
                      {!auth.isAuthenticated && (
                          <Link
                              href="#"
                              onClick={handleLoginRedirect}
                              className="bg-accent shadow-accent-volume hover:bg-accent-dark w-36 rounded-full py-3 px-8 text-center font-semibold text-white transition-all"
                          >
                              Sign In
                          </Link>
                      )}
              </div>
          </div>

          {/* <!-- Hero image --> */}
          <div className="col-span-6 xl:col-span-8">
              <div className="relative text-center md:pl-8 md:text-right">
                  <Image
                      width={560}
                      height={560}
                      src="/images/plantOnHand.png"
                      alt="hero"
                      className="hero-img mt-8 inline-block w-72 rotate-[8deg] sm:w-full lg:w-[24rem] xl:w-[35rem]"
                  />
              </div>
          </div>
      </div>
    </div>
</section>
)
    ;
};

export default Hero;